export enum LanguageRouteParam {
	Language = 'lang',
}
